import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  modal: {
    position: 'absolute',
    top: '10%',
    width: '100vw',

    '& > .ReferaModal-root': {
      maxWidth: '728px !important',
    },
  },
  modalTitle: {
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontSize: '18px',
    color: Theme.Colors.Primary.Base,
  },
  divider: {
    backgroundColor: Theme.Colors.Grayscale.Twelve,
  },
  form: {
    display: 'grid',
    gap: spacing(24),
    marginTop: spacing(24),
    gridRowGap: spacing(32),
    gridTemplateAreas: `"reference_1 reference_2" "area ." "owner cpfCnpj" "phone emails"`,
    gridTemplateColumns: '1fr 1fr',
  },
  reference1: {
    gridArea: 'reference_1',
  },
  reference2: {
    gridArea: 'reference_2',
  },
  area: {
    gridArea: 'area',
  },
  owner: {
    gridArea: 'owner',
    marginTop: spacing(14),
  },
  cpfCnpj: {
    gridArea: 'cpfCnpj',
  },
  phone: {
    gridArea: 'phone',
  },
  emails: {
    gridArea: 'emails',
    marginTop: spacing(4),
  },
  label: {
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontStyle: 'normal',
    fontSize: Theme.Typography.FontSize.Tiny,
    color: Theme.Colors.Grayscale.OneThousand,
  },
  cpfCnpjField: {
    '& .Refera__MaskInput-ErrorMessage': {
      bottom: '-20px',
    },
  },

  actionsModal: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-end',
    marginBottom: spacing(10),
    marginRight: spacing(8),
  },
}))
